import { Authorization } from './UserAPIHelpers/authorization';
import { Branch } from './UserAPIHelpers/branch';
import { ClinicalSupervisor } from './UserAPIHelpers/clinicalSupervisor';
import { Insurance } from './UserAPIHelpers/insurance';
import { User } from './UserAPIHelpers/user';
import { UserSessionAllocation } from './UserAPIHelpers/userSessionAllocation';

export const UserAPI = {
	Authorization,
	ClinicalSupervisor,
	User,
	Insurance,
	Branch,
	UserSessionAllocation,
};
